export default __webpack_public_path__ + "static/media/coming_soon.850d6a4f.gif";